// Hooks
import { useAccess } from '../access'
import { useBuyerSettingsWithDefaults } from '../buyerSettings'
import { useListingDisplay } from '../listing'

export const useLoading = () => {
  const access = useAccess()
  const buyerSettings = useBuyerSettingsWithDefaults()
  const listingEvaluation = useListingDisplay()

  const isGlobalUpdating =
    listingEvaluation?.isFetching || buyerSettings?.isFetching
  const settledRequest = listingEvaluation?.isFetched && !isGlobalUpdating

  return {
    isGlobalUpdating,
    settledRequest,
    isGlobalLoading:
      listingEvaluation?.isLoading ||
      !buyerSettings?.isFetched ||
      access?.isFetching,
  }
}
